const indexInParent = (node) => {
    const children = node.parentNode ? node.parentNode.childNodes : [];
    let num = 0;
    for (let i = 0; i < children.length; i++) {
        if (children[i] == node) {
            return num;
        }
        if (children[i].nodeType == 1) {
            num++;
        }
    }
    return -1;
};
const backgroundAnimate = (content) => {
    const activeItem = content.querySelector('.brandspace__tab-item.active');
    if (!activeItem) {
        return;
    }
    const bgActive = activeItem.querySelector('.active');
    if (!bgActive) {
        return;
    }
    const bgindex = indexInParent(bgActive);
    if (bgindex + 1 == 3) {
        const tabItemBg = activeItem.querySelector('.brandspace__tab-item-bg');
        if (tabItemBg) {
            const firstDiv = tabItemBg.querySelectorAll('div');
            if (firstDiv[0]) {
                firstDiv[0].classList.add('active');
            }
        }
        bgActive.classList.remove('active');
        return false;
    }
    bgActive.classList.remove('active');
    const nextElement = bgActive.nextElementSibling;
    if (nextElement) {
        nextElement.classList.add('active');
    }
};
const init = () => {
    const menu = document.querySelector('.brandspace__tab-menu');
    const content = document.querySelector('.brandspace__tab-content');
    if (!content || !menu) {
        return;
    }
    let intervalAnimate = setInterval(function () {
        backgroundAnimate(content);
    }, 3000);
    menu.querySelectorAll('li').forEach((li) => {
        li.addEventListener('click', () => {
            clearInterval(intervalAnimate);
            intervalAnimate = setInterval(function () {
                backgroundAnimate(content);
            }, 3000);
            const target = li.dataset.targetId;
            const parent = li.parentElement;
            if (parent) {
                const parentActive = parent.querySelector('.acvite');
                if (parentActive) {
                    parentActive.classList.remove('active');
                }
            }
            li.classList.add('active');
            const activeElement = content.querySelector('.brandspace__tab-item.active');
            if (activeElement) {
                activeElement.classList.remove('active');
            }
            const targetElement = content.querySelector('#' + target);
            if (targetElement) {
                targetElement.classList.add('active');
            }
        });
    });
};
export default () => {
    init();
};
